import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setSnackbar } from '../../../redux/actions';
import { api } from '../../../services/api';
import MerchantDropdown from './merchant-dropdown';

import './bulk-match.scss';

class BulkMatch extends Component {
  constructor(props) {
    super(props);

    this.Api = api;
    this.bulk_match_endpoint = '/api/v1/product_match/bam_links/bulk_update/';
    this.undo_endpoint = '/api/v1/product_match/bam_links/bulk_revert/';

    this.displayMsgs = {
      action: 'Select an action.',
      bam_link_ids: 'No Smartlink IDs entered.',
      merch_id: 'A merchant must be selected.',
      bulk_match_success: 'Smartlinks updated.',
      undo_success: 'Bulk match reverted.',
      error: 'Something went wrong.',
      no_dashboard_action_id: 'No bulk match ID entered.',
    };

    this.state = {
      textField: '',
      undoField: '',
      action: '',
      bam_link_ids: [],
      merch_id: null,
    };
  }

  handleLinkField(event) {
    this.setState({ textField: event.target.value });
  }

  handleUndoField(event) {
    this.setState({ undoField: event.target.value });
  }

  async bulkUpdateSmartlinks() {
    /*
     *
     * This page is designed to accept bulk copy pastes. This line takes the text from the
     * the textarea and splits it on comma, newline, and space (one or more) then filters
     * that array for any falsy values. Finally we remove any duplicates from the list.
     */

    const bamLinkIds = [...new Set(this.state.textField.split(/[,\n\s]+/).filter(Boolean))];
    const merchId = this.state.merch_id;
    const { action } = this.state;

    const payload = { bam_link_ids: bamLinkIds, merch_id: merchId, action };
    const payloadKeys = Object.keys(payload);

    for (let i = 0; i < payloadKeys.length; i++) {
      const key = payloadKeys[i];
      const payloadValue = payload[key];

      if (!payloadValue || (payloadValue && payloadValue.length === 0)) {
        this.props.setSnackbar(this.displayMsgs[key]);
        return;
      }
    }

    this.Api.post(this.bulk_match_endpoint, payload)
      .then(() => {
        this.props.setSnackbar(this.displayMsgs.bulk_match_success);
      })
      .catch(() => {
        this.props.setSnackbar(this.displayMsgs.error);
      });
  }

  async undoBulkAction() {
    await this.setState({ displayMsg: null });

    const dashboardActionId = this.state.undoField;
    const payload = { dashboard_action_id: dashboardActionId };

    if (!payload.dashboard_action_id) {
      this.setState({ displayMsg: this.displayMsgs.no_dashboard_action_id });
      return;
    }

    this.Api.post(this.undo_endpoint, payload)
      .then(() => {
        this.setState({ displayMsg: this.displayMsgs.undo_success });
      })
      .catch(() => {
        this.setState({ displayMsg: this.displayMsgs.error });
      });
  }

  goToHomePage() {
    this.props.history.push('/v2/admin');
  }

  setMerchant(merchant) {
    this.setState({ merch_id: merchant.merch_id });
  }

  render() {
    return (
      <div className="bulk-match">
        <h2 className="header">Welcome to the Bulk Match Page</h2>
        <div className="input-fields">
          <div className="top-row">
            <MerchantDropdown setMerchant={merchant => this.setMerchant(merchant)} />

            <div className="action-buttons">
              <input
                type="radio"
                name="action"
                onClick={() => this.setState({ action: 'enable' })}
              />{' '}
              Enable
              <br />
              <input
                type="radio"
                name="action"
                onClick={() => this.setState({ action: 'disable' })}
              />{' '}
              Disable
            </div>
            <div className="exit-buttons">
              <button onClick={this.bulkUpdateSmartlinks.bind(this)}>Complete</button>
              <button onClick={this.goToHomePage.bind(this)}>Cancel</button>
            </div>
          </div>

          <div className="input-form">
            <div className="bulk-match-form">
              <label>Smartlink IDs:</label>
              <br />
              <textarea
                placeholder="Enter the Smartlink IDs (ie Bam Link ID)
									you want to change."
                value={this.state.textField}
                onChange={event => this.handleLinkField(event)}
              />
            </div>
          </div>
          <div className="exit-buttons">
            <button onClick={this.bulkUpdateSmartlinks.bind(this)}>Complete</button>
            <button onClick={this.goToHomePage.bind(this)}>Cancel</button>
          </div>
          <div className="unmatch">
            <div className="input-form">
              <div className="undo-form">
                <label>Dashboard Action ID:</label>
                <br />
                <input
                  type="text"
                  placeholder="Enter the dashboard_action_id to undo"
                  value={this.state.undoField}
                  onChange={event => this.handleUndoField(event)}
                />
              </div>
            </div>
            <div className="bulk-unmatch">
              <div className="exit-buttons">
                <button onClick={this.undoBulkAction.bind(this)}>Undo</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSnackbar: msg => dispatch(setSnackbar(msg)),
  };
};

export default connect(null, mapDispatchToProps)(BulkMatch);
